import React, { useState } from 'react';
import { Tab } from 'semantic-ui-react';

import CommonLayout from '../../layouts/CommonLayout';
import CreateDeviceModal from '../../modals/createDeviceModal';
import { DevicesTable } from './components/DevicesTable';

const Devices = () => {
  const [createDeviceModalOpen, setCreateDeviceModalOpen] = useState(false);

  const panes = [
    { menuItem: 'Active', render: () => <DevicesTable /> },
    { menuItem: 'Archived', render: () => <DevicesTable archived /> },
  ];

  return (
    <CommonLayout
      header={{
        text: 'Devices',
        buttons: [{
          text: 'Create new device',
          color: 'teal',
          onClick: () => setCreateDeviceModalOpen(true),
        }],
      }}

      surface={
        <React.Fragment>
          {
            createDeviceModalOpen ? (
              <CreateDeviceModal
                isOpen={createDeviceModalOpen}
                setOpen={setCreateDeviceModalOpen}
              />
            ) : null
          }

          <Tab
            menu={{ secondary: true, pointing: true, style: { borderBottomWidth: '1px', margin: '20px 0 0' } }}
            panes={panes}
          />
        </React.Fragment>
      }
    />
  );
};

export default Devices;
